import React from 'react'

import StructuredTextReport from '@/components/models/report/structured-text-report/structured-text-report'
import Image from '@/components/image/image'

import * as style from './basic-slide.module.scss'

const BasicSlide = ({ slide, customIndex }) => {
  return (
    <>
      {slide.isQuote ? (
        <>
          <div
            className={`${
              slide.imageDesktop && slide.imagePosition === 'start'
                ? 'order-lg-1 offset-lg-1 col-12 col-lg-6'
                : 'col-12 col-lg-6'
            }`}
          >
            <span className={`tag`}>{slide?.title}</span>
            {slide?.preContent && (
              <StructuredTextReport
                content={slide.preContent}
                className={style.quote}
              />
            )}
            {slide?.content && (
              <StructuredTextReport
                content={slide.content}
                className={style.author}
              />
            )}
          </div>
        </>
      ) : (
        <div
          className={`${
            slide.imageDesktop && slide.imagePosition === 'start'
              ? 'order-lg-1 offset-lg-1 col-12 col-lg-6'
              : 'col-12 col-lg-6'
          }`}
        >
          {slide.isContinued ? null : (
            <span className={`tag`}>{`Insight 0${customIndex}`}</span>
          )}
          <h3 className={`text-base-000 h300 m-0`}>{slide.title}</h3>
          {slide?.preContent && (
            <div className={style.preContent}>
              <StructuredTextReport content={slide.preContent} />
            </div>
          )}

          {slide.imageDesktop && slide?.content && (
            <StructuredTextReport content={slide.content} />
          )}
        </div>
      )}

      <div
        className={`${
          slide.imageDesktop && slide.imagePosition === 'start'
            ? 'order-lg-0 col-12 col-lg-5'
            : 'col-12 col-lg-5 offset-lg-1'
        }`}
      >
        {slide.imageDesktop ? (
          <Image
            image={slide.imageDesktop}
            className={`${style.image} ${
              slide.titleOverImage && style.textOverImage
            }`}
          />
        ) : (
          slide.content && <StructuredTextReport content={slide.content} />
        )}
      </div>
    </>
  )
}

export default BasicSlide
